// HELPERS
import {mergeViewStateForFulfillment} from "../../../Cob.helpers";

export default function (state, prevState)
{
	if (import.meta.env.VITE_CHECK_VIEW_FULFILLMENT === "0")
	{
		return true;
	}

	state = mergeViewStateForFulfillment(state, prevState);
	const {customerState} = state;

	if (customerState.radio_current_risk.length <= 0) {
		return false;
	}

	if (customerState.radio_customer_knowledge_fees === "yes")
	{
		if (customerState.customer_current_fees_details.length <= 0)
		{
			return false;
		}
	}

	if (customerState.customer_current_goals === "yes")
	{
		if (customerState.customer_current_goals_when.length <= 0)
		{
			return false;
		}

		if (customerState.customer_current_goals_reached.length <= 0)
		{
			return false;
		}
	}

	if (customerState.current_solutions_count > 0)
	{
		for (let i = 0; i < customerState.current_solutions_count; i++)
		{
			const sol = customerState.current_solutions[i];
			if (!sol.amount || sol.amount <= 0)
			{
				return false;
			}

			if (!sol.accountType || sol.accountType.length <= 0)
			{
				return false;
			}

			if (!sol.institution || sol.institution.length <= 0)
			{
				return false;
			}

			if (sol.institution === "Annat" && sol.institutionOther.length <= 0)
			{
				return false;
			}

			if (!sol.horizon || sol.horizon.length <= 0)
			{
				return false;
			}

			if (sol.accountType !== "Bankkonto" && (!sol.orientation || sol.orientation.length <= 0))
			{
				return false;
			}

			if ((sol.accountType === "Tjänstepension" ||
				sol.accountType === "Löpande tjänstepension" ||
				sol.accountType === "Pensionsförsäkring") && sol.movable.length <= 0) {
				return false;
			}
		}
	}

	return true;
}